const initState = {
	fetching: false,
	fetched: false,
	error: null,
	payload: {},
	saved: false,
	message: null,
	plant: {},
	isDeleted: false,
};

const plantReducer = (state = initState, action) => {
	switch (action.type) {
		case 'PLANT_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'PLANT_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'PLANT_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				payload: action.payload.data,
				error: null,
				saved: false,
				isDeleted: false
			};
		case 'SAVE_PLANT_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'SAVE_PLANT_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'SAVE_PLANT_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'GET_PLANT_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'GET_PLANT_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'GET_PLANT_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				plant: action.payload.data,
				error: null,
				saved: false,
			};
		case 'UPDATE_PLANT_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'UPDATE_PLANT_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'UPDATE_PLANT_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'DELETE_PLANT_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'DELETE_PLANT_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'DELETE_PLANT_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				isDeleted: true
			};
		default:
			return state;
	}
};

export default plantReducer;
